import type { IAction } from '@chainlit/react-client';

export const IPMA_SOURCE_ACTION = 'ipma_source';

const IPMA_SOURCE_HOSTS = new Set(['ipma.world', 'www.ipma.world']);

export interface IpmaSourceAction {
  id: string;
  label: string;
  url: string;
}

const normaliseLabel = (value: unknown): string => {
  const label =
    typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : '';
  return label.slice(0, 100) || 'IPMA source';
};

const getApprovedSourceUrl = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;

  try {
    const url = new URL(value);
    if (
      url.protocol !== 'https:' ||
      !IPMA_SOURCE_HOSTS.has(url.hostname) ||
      url.username ||
      url.password ||
      url.port
    ) {
      return null;
    }
    return url.href;
  } catch {
    return null;
  }
};

export const getIpmaSourceAction = (
  action: IAction
): IpmaSourceAction | null => {
  if (
    action.name !== IPMA_SOURCE_ACTION ||
    typeof action.id !== 'string' ||
    !action.id ||
    !action.payload ||
    typeof action.payload !== 'object'
  ) {
    return null;
  }

  const url = getApprovedSourceUrl(
    (action.payload as Record<string, unknown>).url
  );
  if (!url) return null;

  return { id: action.id, label: normaliseLabel(action.label), url };
};

export const isIpmaSourceAction = (action: IAction): boolean =>
  getIpmaSourceAction(action) !== null;
